import React, { useEffect, useState } from "react";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";

const AddRole = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });
  const [role, setRole] = useState({
    name: "",
    rank: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRole((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const saveRole = async (e) => {
    e.preventDefault();
    let error = false;
    //console.log(post);
    //return;
    if (role.name === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter role name.",
        };
      });
      return;
    }
    if (role.rank === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter role rank(number).",
        };
      });
      return;
    }

    if (!error) {
      await axios
        .post(
          localStorage.getItem("basurl") + "/roles",
          {
            name: role.name,
            rank: role.rank,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
          setRole({ title: "", description: "", medias: [] });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done! " : "Oops! "}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}

        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Name: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              placeholder="Enter role name"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={role.name}
            />
          </div>
        </div>
        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Rank: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <input
              id="rank"
              name="rank"
              className="form-control"
              placeholder="Enter post description"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={role.rank}
            />
          </div>
        </div>
        <div className="form-layout-footer mg-t-30 tx-right">
          <NavLink to="/admin/roles"> My Roles </NavLink> &nbsp; &nbsp; &nbsp;
          <button
            onClick={saveRole}
            className="btn btn-info"
            style={{ cursor: "pointer" }}
          >
            Save
          </button>
          &nbsp;&nbsp;
        </div>
      </div>
    </>
  );
};

export default AddRole;
